import { isEmptyString, isNotNull } from "utils/types/typeguards";

type Props = {
	productTextId: string
	image?: string
}

function SingleProductPageBanner({ productTextId, image }: Props) {

	const hasAnyElements = () => !isEmptyString(image) && isNotNull(image);

	if (!hasAnyElements()) return <></>

	return (
		<div className="container">
			<img src={ image } alt={ "" }/>
		</div>
	);
}

export default SingleProductPageBanner;